import { configureStore } from "@reduxjs/toolkit";
import { createReducers } from "./appReducers";
import { commonMiddleware } from "../../modules/common";
import { configurationMiddleware } from "../../modules/configuration";
import { languageMiddleware } from "../../modules/language";
import { osservatorioMiddleware } from "../../modules/osservatorio";

const createStore = () => {
  const allReducers = createReducers();
  const store = configureStore({
    reducer: allReducers,
    middleware: (getDefaultMiddleware) => {
      let appSagas = getDefaultMiddleware({
        serializableCheck: {
          // ignoredActionPaths: ["payload.value", "payload.dataDiNascita"],
          // ignoredPaths: ["language.messages"],
        },
      });
      // Aggiungere qui eventuali middlewares
      appSagas = appSagas.prepend(
        commonMiddleware.middleware,
        configurationMiddleware.middleware,
        languageMiddleware.middleware,
        osservatorioMiddleware.middleware
      );
      return appSagas;
    },
    devutility: process.env.NODE_ENV !== "production",
  });
  return { store };
};

const { store } = createStore();

export { store };
